// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__24crR","infected":"Cards_infected__2L8Lg","recovered":"Cards_recovered__1ON7G","deaths":"Cards_deaths__oyPbR"};